/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  GetProfileService,
  IGetProfileMethods,
} from './plugins';

export type UserProfileAgent = IHeaderMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  IGetProfileMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FooterService(),
    new StaticPageContentService(),
    new GetProfileService(),
  ];
};

export const getAgent = () => {
  return createAgent<UserProfileAgent>({
    plugins: getPlugins(),
  });
};
